import { createAction } from '@reduxjs/toolkit';

import { FetchSuperAdminDataPayload, SaveConfigPayload } from './superAdminTypes';

export const fetchSuperAdminData = createAction<FetchSuperAdminDataPayload>('settings/superAdmin/FETCH_DATA');

export const addWhitelistedUrl = createAction<string>('settings/superAdmin/ADD_WHITELISTED_URL');

export const removeWhitelistedUrl = createAction<string>('settings/superAdmin/REMOVE_WHITELISTED_URL');

export const saveHostOptions = createAction<SaveConfigPayload>('settings/superAdmin/SAVE_HOST_OPTIONS');
